/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import errorIcon from "@icons/ic-error-white.svg";
import PersonInChargeList from "../../../../PersonInCharge/PersonInChargeList";
import { daysName } from "@utils/constants";
import SiteFollowUp from "../SiteFollowUp";
import Tabs from "../Tabs/Tabs";
import FinacialInformation from "../FinacialInformation";
import {
  GenrealInfo,
  Title,
  FlexRow,
  ErrorContainer,
  GridRow,
  SubTitle,
  MapContainer,
  ShowMoreData,
} from "./GeneralInfo.styled";
import "../../SiteView.scss";
import { ColumnButton } from "@utils/extra-style";
import initMap from "@utils/mapSingleMarker";

const GeneralInfo = (props) => {
  const { t, siteId, site, updateRefeshStatus } = props;
  const [showLessData, setShowLessData] = useState(
    [3, 10, 12, 13, 14, 15].includes(site.status)
  );
  const [activeTab, setActiveTab] = useState(
    [12, 13, 14, 15].includes(site.status) ? "followUp" : "finacialInformation"
  );

  useEffect(() => {
    if (!!site.address.position.latitude && !!site.address.position.longitude)
      initMap(
        site.address.position.latitude,
        site.address.position.longitude,
        false
      );
  }, []);

  const updateDaysName = (days) => {
    const daysArr = days.split(",");
    return daysArr.map((day, i) => [" " + t(daysName[day.toUpperCase()])]);
  };

  const seeMoreData = (days) => {
    setShowLessData(false);
  };

  useEffect(() => {
    if (
      !showLessData &&
      !!site.address.position.latitude &&
      !!site.address.position.longitude
    )
      initMap(
        site.address.position.latitude,
        site.address.position.longitude,
        false
      );
  }, [showLessData]);

  useEffect(() => {
    if ([12, 13, 14, 15].includes(site.status)) setActiveTab("followUp");
    else setActiveTab("finacialInformation");
  }, [site]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      {[4, 5].includes(site.status) && (
        <ErrorContainer>
          <GridRow column="30px auto">
            <div>
              <Image
                src={errorIcon}
                marginTop="6px"
                className="site-view-enquiry__general-icon"
              />
            </div>
            <div>
              <span>
                {site.status === 5
                  ? t("SITE_STATUS_LOST_CLIENT").toUpperCase()
                  : t("SITE_STATUS_LOST_HESUS").toUpperCase()}
              </span>
              <p>
                {t("SITE_LOST_INFO_MESSAGE") + `  `}{" "}
                {site.lostComment ? site.lostComment : " "}
              </p>
            </div>
          </GridRow>
        </ErrorContainer>
      )}
      <GenrealInfo>
        {!showLessData && (
          <FlexRow column="1fr">
            <Title>{t("GENERAL_INFORMATION")}</Title>
          </FlexRow>
        )}
        <GridRow column={showLessData ? "50% 50%" : "60% auto"}>
          <div>
            {showLessData && (
              <FlexRow column="1fr">
                <Title>{t("GENERAL_INFORMATION")}</Title>
              </FlexRow>
            )}
            <FlexRow>
              <SubTitle fontWeight="700">
                {t("SITE_ESTIMATED_DATES")} :
              </SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {site.estimatedStartDate +
                  ` ` +
                  t("GENERAL_TO") +
                  " " +
                  site.estimatedEndDate}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <SubTitle fontWeight="700">{t("SITE_TYPE")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {site.isTender === true && t("SITE_TYPE_TENDER")}
                {site.isTender !== true && t("SITE_TYPE_LIVE")}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <SubTitle fontWeight="700">{t("SITE_ADDRESS")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {site.address.street ? site.address.street + " " : " "}

                {parseInt(site.address.country, 10) === 1 && (
                  <>
                    {site.address.city ? " " + site.address.city : ""}
                    {site.address.zipcode ? ", " + site.address.zipcode : " "}
                  </>
                )}
                {parseInt(site.address.country, 10) !== 1 && (
                  <>
                    {site.address.zipcode ? site.address.zipcode + ", " : " "}
                    {site.address.city ? " " + site.address.city : ""}
                  </>
                )}

                {site.address.supplement ? " - " + site.address.supplement : ""}
              </SubTitle>
            </FlexRow>
            {showLessData && (
              <FlexRow>
                <SubTitle fontWeight="700">
                  {"> "}{" "}
                  <ShowMoreData onClick={() => seeMoreData()} rel="noreferrer">
                    {t("ACTION_SEE_MORE")}
                  </ShowMoreData>
                </SubTitle>
              </FlexRow>
            )}
          </div>

          <div>
            <div>
              {showLessData &&
                !!site.address.position.latitude &&
                !!site.address.position.longitude && (
                  <MapContainer id="map" marginTop="20px;" />
                )}
            </div>

            {!showLessData && (
              <>
                {site.status === 3 && (
                  <ColumnButton
                    border="#008395"
                    background="#008395"
                    marginRight="20px"
                    float="right"
                    height="50px"
                    padding="5px 20px 5px 20px"
                  >
                    <span style={{ fontSize: "14px", color: "#CCCCCC" }}>
                      {t("SITE_CLOSING_DATE")}
                    </span>
                    <p style={{ fontSize: "14px", color: "#FFFFFF" }}>
                      {site.closingDate}
                    </p>
                  </ColumnButton>
                )}

                {[1, 2, 9, 11].includes(site.status) && (
                  <ColumnButton
                    border="#EBF7ED"
                    background="#EBF7ED"
                    marginRight="20px"
                    float="right"
                    height="50px"
                    padding="5px 20px 5px 20px"
                  >
                    <span style={{ fontSize: "14px", color: "#0A4986" }}>
                      {t("SITE_EXPECTED_CLOSING_DATE")}
                    </span>
                    <p style={{ fontSize: "14px", color: "#474747" }}>
                      {site.expectedClosingDate}
                    </p>
                  </ColumnButton>
                )}
              </>
            )}
          </div>
        </GridRow>
        {!showLessData && (
          <>
            <GridRow column="1fr">
              <div>
                {!!site.address.position.latitude &&
                  !!site.address.position.longitude && (
                    <MapContainer id="map" height="300px;" />
                  )}
              </div>
            </GridRow>
            <GridRow>
              {site.clientComment && (
                <FlexRow>
                  <SubTitle fontWeight="700">
                    {t("SITE_CLIENT_INFORMATION")} :
                  </SubTitle>
                  <SubTitle color="#767676" paddingLeft="10px">
                    {site.clientComment}
                  </SubTitle>
                </FlexRow>
              )}
              <FlexRow>
                <SubTitle fontWeight="700">
                  {t("SITE_ADMIN_INFORMATION")} :
                </SubTitle>
                <SubTitle color="#767676" paddingLeft="10px">
                  {site.adminComment ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: site.adminComment,
                      }}
                    ></div>
                  ) : (
                    "-"
                  )}
                </SubTitle>
              </FlexRow>
            </GridRow>

            <FlexRow column="1fr">
              <Title>{t("SITE_OPTIMIZATION")}</Title>
            </FlexRow>
            <GridRow column="1fr 1fr">
              <div>
                <FlexRow>
                  <SubTitle fontWeight="700">{t("WORKING_HOURS")} :</SubTitle>
                </FlexRow>

                {site?.workingHours?.length > 0 &&
                  site.workingHours.map((hour) => {
                    return (
                      <FlexRow key={"workinghour-company-" + hour.id}>
                        <SubTitle color="#767676">
                          {hour.openingHour +
                            " - " +
                            hour.closingHour +
                            " /" +
                            updateDaysName(hour.selectedDays)}
                        </SubTitle>
                      </FlexRow>
                    );
                  })}
              </div>
              <div>
                <FlexRow>
                  <SubTitle fontWeight="700">
                    {t("LOADING_UNLOADING_TIME")} :
                  </SubTitle>
                  <SubTitle color="#767676" paddingLeft="10px">
                    {site.loadingTime +
                      " " +
                      t("MINUTES_ABREVIATED") +
                      "/" +
                      site.unloadingTime +
                      t("MINUTES_ABREVIATED")}
                  </SubTitle>
                </FlexRow>

                <FlexRow>
                  <SubTitle fontWeight="700">
                    {t("SIMULTANEOUS_LOADS_UNLOADS")} :
                  </SubTitle>
                  <SubTitle color="#767676" paddingLeft="10px">
                    {t(site.simultaneousLoads) +
                      " / " +
                      t(site.simultaneousUnloads)}
                  </SubTitle>
                </FlexRow>
              </div>
            </GridRow>
          </>
        )}
      </GenrealInfo>
      <Tabs toggleTab={toggleTab} data={site} activeTab={activeTab} />
      {[12, 13, 14, 15].includes(site.status) && activeTab === "followUp" && (
        <SiteFollowUp
          siteId={siteId}
          siteNeedKickoff={parseInt(site?.needKickoff, 10)}
        />
      )}
      {activeTab === "finacialInformation" && (
        <FinacialInformation
          data={site}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
      <PersonInChargeList
        objectId={siteId}
        objectType="jobsite"
        columnName="siteId"
        countryId={site?.platformCountry?.id}
      />
    </>
  );
};
GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(GeneralInfo);
